import React from 'react'

const Header = () => {
  return (
    <div className='header'>
      <h1>Список задач</h1>
    </div>
  )
}

export default Header